import firebase, {db, auth, fc} from './connection'

export default {
    createCustomer(payload) {
        let createCustomer = fc.httpsCallable('createCustomer');

        return createCustomer(payload)
                    .then(response => {
                        return {status: true, content: response.data};
                    })
                    .catch(error => {
                        return error;
                    });
    },

    getSubscriber(id) {
        let ref = db.collection('subscribers').doc(id)

        return ref.get()
                .then(doc => {
                    return {status: true, doc: doc}
                })
                .catch(error => {
                    return error;
                });
    },

    createSubscription(payload) {
        let createSubscription = fc.httpsCallable('createSubscription');

        return createSubscription(payload)
                    .then(response => {
                        return {status: true, content: response.data};
                    })
                    .catch(error => {
                        return error;
                    });
    },

    getAcceptedSubscriber(id) {
        let ref = db.collection('acceptedSubscribers').where('stripeCustomerId', '==', id)

        return ref.get()
                .then(query => {
                    return {status: true, query: query}
                })
                .catch(error => {
                    console.log(error)
                    return error;
                });
    },

}